import React from 'react';
import './Footer.css';
import { Button } from '@fluentui/react-components';
import { TabConfig } from '../../../types/TabConfig';



interface FooterProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  tabs: TabConfig[];
}

const Footer: React.FC<FooterProps> = ({ activeTab, setActiveTab, tabs }) => {
  return (
    <div className="bottom-tray-container" role="navigation">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`bottom-tray__tab-wrapper ${activeTab === tab.key ? 'active-tab' : ''}`}
        >
          <Button
            icon={tab.icon ? <span>{tab.icon}</span> : undefined} 
            className="bottom-tray__tab-button ms-fcl-nd"
            onClick={() => setActiveTab(tab.key)}
            id={`bottom-tray-tab-${tab.key}`}
          >
            {tab.label}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default Footer;
